import { useI18n } from '../../i18n/I18nProvider'

/**
 * Diagrama do fluxo de derivação.
 *
 * SVG inline com `currentColor` e tokens de tema, para ficar legível no claro e
 * no escuro sem duas versões. Em telas estreitas ele rola horizontalmente
 * dentro do próprio contêiner em vez de espremer os rótulos.
 */
export function FlowDiagram() {
  const { t } = useI18n()
  const d = t.how.diagram

  return (
    <figure className="surface-card overflow-hidden">
      <div className="overflow-x-auto p-4 sm:p-6">
        <svg
          // Altura justa ao conteúdo (as caixas terminam em y=240); a legenda
          // saiu do SVG e deixaria uma faixa vazia se a viewBox continuasse 300.
          viewBox="0 0 720 262"
          className="h-auto w-[680px] max-w-none sm:w-full"
          role="img"
          aria-label={d.title}
        >
          <defs>
            <linearGradient id="ard-flow-accent" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="var(--color-accent)" />
              <stop offset="100%" stopColor="var(--color-accent-2)" />
            </linearGradient>
            <marker
              id="ard-arrow"
              viewBox="0 0 10 10"
              refX="9"
              refY="5"
              markerWidth="6"
              markerHeight="6"
              orient="auto-start-reverse"
            >
              <path d="M0 0 L10 5 L0 10 z" fill="var(--color-border-strong)" />
            </marker>
          </defs>

          {/* Entradas */}
          <g>
            <rect
              x="8"
              y="30"
              width="196"
              height="72"
              rx="14"
              fill="var(--color-surface-2)"
              stroke="var(--color-accent)"
              strokeWidth="1.5"
            />
            <text x="24" y="58" className="fill-[var(--color-fg)] text-[15px] font-semibold">
              {d.master}
            </text>
            <text x="24" y="80" className="fill-[var(--color-accent)] text-[12px]">
              {d.secret}
            </text>

            <rect
              x="8"
              y="150"
              width="196"
              height="90"
              rx="14"
              fill="var(--color-surface-2)"
              stroke="var(--color-border)"
              strokeWidth="1.5"
            />
            <text x="24" y="178" className="fill-[var(--color-fg-muted)] text-[12px]">
              {d.public}
            </text>
            <foreignObject x="20" y="185" width="176" height="50">
              <div className="text-[13px] leading-snug text-[var(--color-fg)]">{d.service}</div>
            </foreignObject>
          </g>

          {/* SHA-256 → salt */}
          <path
            d="M204 195 H250"
            stroke="var(--color-border-strong)"
            strokeWidth="1.5"
            markerEnd="url(#ard-arrow)"
          />
          <rect
            x="252"
            y="168"
            width="120"
            height="54"
            rx="12"
            fill="var(--color-surface)"
            stroke="var(--color-border)"
            strokeWidth="1.5"
          />
          <text x="312" y="190" textAnchor="middle" className="fill-[var(--color-fg)] text-[13px] font-semibold">
            {d.sha}
          </text>
          <text x="312" y="208" textAnchor="middle" className="fill-[var(--color-fg-subtle)] text-[11px]">
            {d.salt}
          </text>

          {/* Convergência no Argon2id */}
          <path
            d="M204 66 H420 V150"
            fill="none"
            stroke="var(--color-accent)"
            strokeWidth="1.75"
            markerEnd="url(#ard-arrow)"
          />
          <path
            d="M372 195 H420"
            stroke="var(--color-border-strong)"
            strokeWidth="1.5"
            markerEnd="url(#ard-arrow)"
          />

          <rect
            x="404"
            y="150"
            width="132"
            height="90"
            rx="14"
            fill="url(#ard-flow-accent)"
            opacity="0.14"
          />
          <rect
            x="404"
            y="150"
            width="132"
            height="90"
            rx="14"
            fill="none"
            stroke="url(#ard-flow-accent)"
            strokeWidth="2"
          />
          <text x="470" y="186" textAnchor="middle" className="fill-[var(--color-fg)] text-[15px] font-semibold">
            {d.argon}
          </text>
          <text x="470" y="206" textAnchor="middle" className="fill-[var(--color-fg-muted)] text-[11px]">
            {d.argonParams}
          </text>
          <text x="470" y="224" textAnchor="middle" className="fill-[var(--color-fg-subtle)] text-[11px]">
            {d.key}
          </text>

          {/* Mapeamento → senha */}
          <path
            d="M536 195 H584"
            stroke="var(--color-border-strong)"
            strokeWidth="1.5"
            markerEnd="url(#ard-arrow)"
          />
          <rect
            x="586"
            y="150"
            width="126"
            height="90"
            rx="14"
            fill="var(--color-surface-2)"
            stroke="var(--color-accent-2)"
            strokeWidth="1.5"
          />
          <text x="649" y="182" textAnchor="middle" className="fill-[var(--color-fg-subtle)] text-[11px]">
            {d.map}
          </text>
          <text
            x="649"
            y="210"
            textAnchor="middle"
            className="fill-[var(--color-fg)] text-[15px] font-semibold"
          >
            {d.password}
          </text>

        </svg>
      </div>
      {/* A legenda fica FORA do SVG de propósito: dentro dele, ela sumiria junto
          com o resto do desenho na rolagem horizontal do celular — que é
          exatamente onde ela mais precisa ser lida. */}
      <figcaption className="border-t border-border px-4 py-3 text-xs text-pretty text-fg-subtle sm:px-6">
        {d.caption}
      </figcaption>
    </figure>
  )
}
